import { SchemeType } from '@/shared/types/api.types'

export const PLAN_NAMES_HASH: Record<string, string> = {
  '5007': 'outbound.plan.worldwide.name',
  '5003': 'outbound.plan.worldwide.name',
  '5006': 'outbound.plan.wordldwide_ex.name',
  '5002': 'outbound.plan.wordldwide_ex.name',
  '5005': 'outbound.plan.regional.name',
  '5001': 'outbound.plan.regional.name',
  '5008': 'outbound.plan.fly_europe.name',
  '5004': 'outbound.plan.fly_europe.name',
  '5045': 'outbound_plans_ramadan_name',

  '5055': 'outbound.plan.worldwide.name',
  '5054': 'outbound.plan.wordldwide_ex.name',
  '5056': 'outbound.plan.fly_europe.name',
  '5053': 'outbound.plan.regional.name',

  '5064': 'outbound.plan.worldwide.name',
  '5065': 'outbound.plan.wordldwide_ex.name',
  '5066': 'outbound.plan.fly_europe.name',
  '5063': 'outbound.plan.regional.name',
}

export const OUTBOUND_MULTI_TRIP_RETURN_DAY = 364

export const PLAN_NAMES_SCHEME_TYPE_CODE_MAP = {
  [SchemeType.Worldwide]: 'outbound.select_plan.insurance_values.plan.worldwide.name',
  [SchemeType.WorldwideExcl]: 'outbound.select_plan.insurance_values.plan.worldwideexcl.name',
  [SchemeType.Regional]: 'outbound.select_plan.insurance_values.plan.regional.name',
  [SchemeType.FlyEurope]: 'outbound.select_plan.insurance_values.plan.flyeurope.name',
}

export const PLAN_NAMES_SCHEME_TYPE_CODE_MAP_V3 = {
  [SchemeType.Worldwide]: 'outbound.plan.worldwide.name',
  [SchemeType.WorldwideExcl]: 'outbound.plan.worldwide_limited.name',
  [SchemeType.Regional]: 'outbound.plan.regional.name',
  [SchemeType.FlyEurope]: 'outbound.plan.europe.name',
}
